import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { AdvancedSearch } from "../../../../components/advanced-search/AdvancedSearch";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { PageTitle } from "../../../../components/ui-kit";
import { SearchFieldType } from "../../../../components/advanced-search/AdvancedSearch.interface";
import { useTableContext } from "../../../../components/ui-kit/ReactTable/context/TableContext";
import SuppliersTable from "../components/SuppliersTable";
import { companySearchConfig } from "../config/searchConfig";
import { useGetSuppliers, SuppliersFilters } from "../hooks/useSuppliers";
import { ISortConfig } from "../../../../components/ui-kit/ReactTable/context/TableContext";

const Container = styled.div<{ details?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ details }) => details && "margin-top: 30px;"}
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const TableContainer = styled.div<{ details?: boolean }>`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  ${({ details }) =>
    !details &&
    `border: 1px solid #eeeeee;
    border-radius: 10px;
    padding: 30px 20px;`}
  box-sizing: border-box;

  @media (max-width: 900px) {
    padding: ${({ details }) => (details ? "0" : "12px")};
  }
`;

export interface SuppliersListProps {
  ownerId?: string;
  details?: boolean;
}
export const SuppliersList: React.FunctionComponent<SuppliersListProps> = ({
  ownerId,
  details,
}) => {
  const { sortConfig } = useTableContext();
  const [filters, setFilters] = useState<SuppliersFilters>({});
  const [sort, setSort] = useState<ISortConfig>(() => {
    // Initialize with sortConfig if available, otherwise use default
    return (
      sortConfig || {
        field: "createdAt",
        direction: "desc",
      }
    );
  });

  const { suppliers, onPaginationChange, totalDocs, limit, page, loading } =
    useGetSuppliers(filters, sort, ownerId);

  useEffect(() => {
    // Only update sort if sortConfig is defined and different from current sort
    if (
      sortConfig &&
      sortConfig.field &&
      (sortConfig.field !== sort.field ||
        sortConfig.direction !== sort.direction)
    ) {
      setSort(sortConfig);
    }
  }, [sortConfig, sort.field, sort.direction]);

  const searchConfig = ownerId
    ? companySearchConfig.filter(
        (field) => field.type !== SearchFieldType.SEARCH_BY_COMPANY_DROPDOWN
      )
    : companySearchConfig;
  return (
    <AnimateAppearanceWrapper>
      <Container details={details}>
        <TopLine>
          <PageTitle title="Suppliers" />
        </TopLine>
        <TableContainer details={details}>
          <AdvancedSearch config={searchConfig} onChange={setFilters} />
          <SuppliersTable
            data={suppliers}
            pagination={{ page, limit, totalDocs, onPaginationChange }}
          />
        </TableContainer>
      </Container>
    </AnimateAppearanceWrapper>
  );
};
